import { UserSubmittableDataBatch } from './user-submittable-data-batch';
import { InjectionDataRecord } from "./injection-data-record";

export class InjectionDataBatch extends UserSubmittableDataBatch {

}
